import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { ANIMATION_CLASSES } from '@/js/lib/constants';
import { TRIGGER_START } from './base';

gsap.registerPlugin(ScrollTrigger);

const els = document.querySelectorAll<HTMLHRElement>('.js-animate-rule');

export default function animateRule(el: HTMLHRElement) {
  gsap.set(el, {
    scaleX: 0,
  });

  el.classList.add(ANIMATION_CLASSES.rigged);

  gsap.to(el, {
    scrollTrigger: {
      trigger: el,
      start: TRIGGER_START,
    },
    ease: 'custom-ease',
    scaleX: 1,
    transformOrigin: '0',
    duration: 1.4,
    delay: 0.2,
  });
}

els.forEach(animateRule);
